import React from 'react';
import './terms.scss'
interface Props {
	show: boolean,
	hide: (show: boolean) => void
}
function Privacy({show, hide}: Props) {
	return (
		<div>
			{show && <div className="modal fade" data-backdrop="static" data-keyboard="false" tabIndex={-1}
			     aria-labelledby="staticBackdropLabel" aria-hidden="true">
				<div className="modal-dialog">
					<div className="modal-content">
						<div className="modal-header">
							<h5 style={{color:'black'}} className="modal-title" id="staticBackdropLabel">Съгласен/а съм с "УВЕДОМЛЕНИЕ ОТНОСНО ОБРАБОТКАТА НА ЛИЧНИ ДАННИ"</h5>
						</div>
						<div className="modal-body">
							<p style={{color:'black'}}>Давам съгласието си личните данни, предоставени в регистрационната форма, да бъдат обработвани от
								Метрорадио ЕООД за целите на регистриране и отчитане на моя вот за Годишните музикални награди
								на БГ радио {new Date().getFullYear()}.
								Информиран съм, че мога да оттегля моето съгласие по всяко време, като изпратя електронно
								съобщение до следния email адрес:office@bgradio.net. Съзнавам, че оттеглянето на съгласието ми
								не засяга законосъобразността на обработването преди неговото оттегляне.</p>
						</div>
						<div className="modal-footer">
							<button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={() => hide(!show)}>Затвори</button>
						</div>
					</div>
				</div>
			</div>}
		</div>
	);
}

export default Privacy;